import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import pathfinder from '@fiverr-private/pathfinder';
import Image from '../../../logged_out_homepage/shared/Image';
import SafeComponent from '../../../logged_out_homepage/shared/SafeComponent';
import { sendBigQueryEvent } from '../../../logged_out_homepage/utils/biEvents';
import { BQ_CLICKED_HOMEPAGE_LO_GET_STARTED } from '../../../logged_out_homepage/utils/biEvents/events/bigQueryEvents';
import { LOHP_ROW } from '../../../logged_out_homepage/utils/constants';
import { pictureData, imgSrc } from './config';

import styles from './styles.module.scss';

const FindExperts = () => {
  const pathToJoin = pathfinder('join', undefined, { query: { source: 'hplo_get_started' } });

  const onClick = async (event) => {
    event.preventDefault();

    sendBigQueryEvent({ eventName: BQ_CLICKED_HOMEPAGE_LO_GET_STARTED });
    await triggerSignUp({
      modalOptions: {
        triggerType: 'user_trigger',
        triggerId: 'hplo_get_started',
      },
    });
  };

  return (
    <div className={classNames(styles.findExpertsWrapper, LOHP_ROW)}>
      <picture className={styles.bannerImageWrapper}>
        {pictureData.map((image, index) => (
          <source key={index} media={image.media} srcSet={image.srcSet} />
        ))}
        <Image
          src={imgSrc}
          loading="lazy"
          alt="logged_out_homepage.de.qualified_experts_banner.alt"
          className={styles.bannerImage}
        />
      </picture>
      <div className={styles.bannerTextWrapper}>
        <h2 className={classNames(styles.bannerText, 'text-display-1')}>
          <I18n
            k="logged_out_homepage.de.qualified_experts_banner.title"
            templates={{
              span: (text) => (
                <span className="font-domaine text-semi-bold">
                  <i>{text}</i>
                </span>
              ),
            }}
          />
        </h2>
        <Button href={pathToJoin} className="btn-signup" onClick={onClick}>
          <I18n k="logged_out_homepage.de.qualified_experts_banner.cta" />
        </Button>
      </div>
    </div>
  );
};

export default SafeComponent(FindExperts);
